export default __webpack_public_path__ + "static/media/pakrap-5.44eb9a46.mp3";